import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    locales: ['en-US', 'zh-CN'],
    locale: 'en-US',
    // locale: 'zh-CN',
  },
  mutations: {
    SET_LANG(state, locale) {
      if (state.locales.indexOf(locale) !== -1) {
        state.locale = locale
      }
    }
  },
  actions: {},
  modules: {}
})